import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Icon } from "@/components/Icon";

// Reusable branded play button. Opens a modal that plays a real video when a URL
// is configured (admin), otherwise shows a polished "coming soon" message.
export function PlayButton({ onClick, label = "See how we care", sublabel = "Watch video", variant = "row", testid = "play-button" }) {
  if (variant === "overlay") {
    return (
      <button type="button" onClick={onClick} data-testid={testid} aria-label={`${label} — ${sublabel}`}
        className="group absolute inset-0 flex items-center justify-center focus:outline-none">
        <span className="flex h-20 w-20 items-center justify-center rounded-full bg-white/90 text-brand-teal shadow-2xl ring-4 ring-white/40 transition-transform duration-300 group-hover:scale-110">
          <Icon name="Play" weight="fill" size={30} className="ml-1" />
        </span>
      </button>
    );
  }
  return (
    <button type="button" onClick={onClick} data-testid={testid}
      className="group flex items-center gap-3 focus:outline-none">
      <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-brand-teal text-white shadow-lg transition-transform duration-300 group-hover:scale-110">
        <Icon name="Play" weight="fill" size={20} className="ml-0.5" />
      </span>
      <span className="text-left">
        <span className="block font-heading text-base font-semibold text-white">{label}</span>
        <span className="block text-sm text-slate-200">{sublabel}</span>
      </span>
    </button>
  );
}

export function VideoModal({ open, onOpenChange, videoUrl }) {
  const [failed, setFailed] = useState(false);
  const showVideo = videoUrl && !failed;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl overflow-hidden rounded-2xl border-0 p-0" data-testid="video-modal">
        {showVideo ? (
          <>
            <DialogTitle className="sr-only">CareDeserved video</DialogTitle>
            <DialogDescription className="sr-only">A closer look at how we provide Care Beyond the Ride.</DialogDescription>
            <div className="aspect-video w-full bg-black">
              <video src={videoUrl} controls autoPlay playsInline onError={() => setFailed(true)} className="h-full w-full" data-testid="video-player" />
            </div>
          </>
        ) : (
          <div className="relative bg-brand-blue noise-overlay px-8 py-14 text-center">
            <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-brand-teal text-white shadow-xl">
              <Icon name="Play" weight="fill" size={28} className="ml-1" />
            </span>
            <DialogTitle className="mt-6 font-heading text-2xl font-bold text-white">CareDeserved stories are coming soon</DialogTitle>
            <DialogDescription className="mx-auto mt-3 max-w-md text-base leading-relaxed text-slate-300">
              We're preparing a closer look at how we provide Care Beyond the Ride.
            </DialogDescription>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
